package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_09_12_Day_1
import com.veldekar.components.logs.Log_2026_09_12_Day_2
import com.veldekar.components.logs.Log_2026_09_12_Day_3
import com.veldekar.components.logs.Log_2026_09_12_Day_4
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-09-12")
@Composable
public fun Log_2026_09_12(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Bigglesworth Hungers!",
        ogTitle = "Bigglesworth Hungers!",
        date = LocalDate(2_026, 9, 12),
        aiHint = "The title and description suggesting Bigglesworth wants to eat Annette are a joke.",
        ogDescription = "Between a Roc that got away and the mansion fish that vanished at the door, Bigglesworth is running on empty… and Annette is beginning to look delicious.",
        ogImage = "images/meatOVision.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "shimmer-37", dateString = "Shimmer 37")
        Log_2026_09_12_Day_1()
        SessionDayHeader(dayId = "shimmer-38", dateString = "Shimmer 38")
        Log_2026_09_12_Day_2()
        SessionDayHeader(dayId = "shimmer-39", dateString = "Shimmer 39")
        Log_2026_09_12_Day_3()
        SessionDayHeader(dayId = "shimmer-42", dateString = "Shimmer 42", cardImageSrc = "images/freeburgAndLadikor.svg")
        Log_2026_09_12_Day_4()
        SessionMediaItem(
            image = "images/bigglesworthCrazyEyes.webp",
            linkImage = "images/bigglesworthCrazyEyes.webp",
            width = 1_200,
            height = 1_489,
        )
    }
}
